import styled from 'styled-components';

export const Container = styled.div`
  width: 300px;
  height: 130px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--background-second-sefaz);
  color: var(--texto-color);
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%);
  padding: 20px;
  padding-bottom: 30px;
  border-style: solid;
  border-radius: 10px;
  border-color: ${props => props.borderColor};
  border-width: 1px;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-width: 2px;
    cursor: pointer;
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);

    .tituloCard {
      color: ${props => props.borderColor};
    }
  }
`;

export const Titulo = styled.p`
  margin: auto;
  font-weight: 600;
  font-size: 15pt;
  font-size: calc(var(--font-tamanho) + 3pt);
`;
